export const removeArrayElementMutable =
  <T,>(element: T) =>
  (array: T[]): void => {
    const index = array.indexOf(element);
    if (index > -1) {
      array.splice(index, 1);
    }
  };
